import { Translator } from "@itarget/shared/";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  expiredBelt: {
    textAlign: "center",
    position: "absolute",
    transform: "rotate(35deg)",
    boxShadow: theme.shadows[1],
    paddingTop: theme.spacing(0.5),
    top: theme.typography.pxToRem(14),
    right: theme.typography.pxToRem(-42),
    width: theme.typography.pxToRem(160),
    height: theme.typography.pxToRem(32),
    backgroundColor: theme.palette.error.main,
    "& .MuiTypography-root": {
      fontWeight: "bold",
      color: theme.palette.error.contrastText,
    },
  },
}));

export const ExpiredBelt = ({ children = "Vencido", className }) => {
  const styles = useStyles();
  return (
    <Box className={`${styles.expiredBelt} ${className}`}>
      <Typography variant="caption">
        <Translator transRef={`translation.${children}`} />
      </Typography>
    </Box>
  );
};
